<template>
    <v-card-text>
        <v-row no-gutters>
            <v-col cols="12">
                <h5 class="text-h5 mb-0">Logo</h5>
                <v-file-input
                    accept="image/png,image/jpg"
                    v-show="false"
                    ref="logo"
                    id="companyLogo"
                    @update:model-value="fileLogoChange"
                />
            </v-col>
            <v-col cols="12" v-if="invoiceSettings.logo" class="d-flex justify-center">
                <v-hover
                    v-slot="{ isHovering, props }"
                    v-if="invoiceSettings.logo.signedUrl"
                >
                    <v-img
                        v-bind="props"
                        :src="invoiceSettings.logo.signedUrl"
                        style="width: 100%; max-width: 200px; cursor: pointer"
                        @click="setLogoInput()"
                    >
                        <v-expand-transition>
                            <div
                                v-if="isHovering"
                                class="d-flex align-center justify-center transition-fast-in-fast-out justify-center primary bg-black v-card--reveal display-3 white--text"
                                style="height: 100%; cursor: pointer"
                            >
                                <v-icon size="x-large">$edit</v-icon>
                            </div>
                        </v-expand-transition>
                    </v-img>
                </v-hover>
            </v-col>
            <v-col cols="12" class="d-flex justify-center pt-3">
                <v-btn elevation="0" @click="setLogoInput()" size="small">
                    {{ invoiceSettings.logo ? "Modifier" : "Ajouter" }} le logo de la société
                </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script lang="ts">
import axios from "axios";

import gql from "graphql-tag";

import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["logoChange"],
})
export class LogoConfiguration extends Vue {
    @Prop({ default: null }) companyId;

    @Apollo(
        {
            query: gql`
                query invoiceSettings($companyId: ID!) {
                    company(where: { id: $companyId }) {
                        id
                        invoiceTextPaymentDetails
                        invoiceTextLegalNotices
                        logo {
                            id
                            key
                            signedUrl
                        }
                    }
                }
            `,
            skip() {
                return !this.companyId;
            },
            variables() {
                return {
                    companyId: this.companyId,
                };
            },
        },
        (data) =>
            data ? data.company : { invoiceTextPaymentDetails: "", invoiceTextLegalNotices: "" }
    )
    invoiceSettings = {
        invoiceTextPaymentDetails: "",
        invoiceTextLegalNotices: "",
        logo: null,
    };

    async fileLogoChange(file) {
        // debugger
        // console.log("change", file)
        if (file) {
            // console.log("type", file.type)

            const res: any = await this.$apollo.query({
                query: gql`
                    query fileUploadSignedURL(
                        $name: String!
                        $sha256: String
                        $contentType: String!
                        $companyId: ID!
                    ) {
                        fileUploadSignedURL(
                            data: {
                                name: $name
                                sha256: $sha256
                                contentType: $contentType
                                companyId: $companyId
                            }
                        ) {
                            status
                            url
                            key
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    name: file.name,
                    sha256: undefined,
                    contentType: file.type,
                    companyId: this.companyId,
                },
            });

            let type = "";
            if (file.type === "image/png") type = "PNG";
            else if (file.type === "image/jpg") type = "JPG";
            else if (file.type === "image/jpeg") type = "JPEG";
            else if (file.type === "image/tiff") type = "TIFF";
            else if (file.type === "image/tif") type = "TIF";

            // debugger

            axios
                .put(res.data.fileUploadSignedURL.url, file, {
                    headers: {
                        "Content-Type": file.type,
                    },
                })
                .then(async () => {
                    const result = await this.$apollo.mutate({
                        mutation: gql`
                            mutation addLogo($companyId: ID!, $key: String!, $type: FileType!) {
                                updateCompany(
                                    where: { id: $companyId }
                                    data: { logo: { create: { key: $key, type: $type } } }
                                ) {
                                    id
                                    logo {
                                        id
                                        key
                                        signedUrl
                                    }
                                }
                            }
                        `,
                        variables: {
                            companyId: this.companyId,
                            key: res.data.fileUploadSignedURL.key,
                            type: type,
                        },
                    });
                    this.invoiceSettings.logo.signedUrl = result.data.updateCompany.logo.signedUrl;
                })
                .catch(() => {
                    console.log("FAILURE!!");
                });
        }
    }

    @Watch("invoiceSettings.logo")
    onLogoChange() {
        this.$emit("logoChange", this.invoiceSettings.logo);
    }

    setLogoInput() {
        console.log(this.$refs.logo);
        document.getElementById("companyLogo").click();
    }
}

export default toNative(LogoConfiguration);
</script>
